export const websiteName = "Christengemeinde Waldsassen"
export const defaultDescription = "Glaube an den Herrn Jesus Christus, so wirst du gerettet werden."
export const canonicalOrigin = "https://www.christengemeinde-waldsassen.de"

export const config = {
  pages: {
    index: "/",
    impressum: "/impressum",
    datenschutz: "/datenschutz",
  },
  phone: "09632 / 916309",
  email: "info@christengemeinde-waldsassen.de",
  street: "Mühlbachgasse 8",
  zipCode: "95652",
  city: "Waldsassen",
} as const

export const directionsLink = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
  `${config.street}, ${config.zipCode} ${config.city}`,
)}`

export const seoKeywords = [
  "jesus",
  "christ",
  "christen",
  "bibel",
  "gemeinde",
  "gemeinschaft",
  "glaube",
  "gläubig",
  "waldsassen",
  "gottesdienst",
  "sonntag",
  "evangelisch",
  "freikirchlich",
  "freikirche",
]
